const e = "Appartamenti", i = "Appartamenti", s = "Azienda", t = "Campeggi", o = "Coppia", n = "Famiglia", a = "Amici", r = "Ostelli", l = "Hotel", c = "Resorts", m = "Ristoranti", p = {
  "{num} reviews": "{num} recensioni",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} a {location}",
  "All languages": "Tutte le lingue",
  "All traveler types": "Tutti i tipi di viaggiatori",
  Aparthotels: e,
  Apartments: i,
  "Arrow icon": "Icona della freccia",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "basato su {number} recensioni",
  Business: s,
  Campsites: t,
  Couple: o,
  Family: n,
  Friend: a,
  "Highlighted reviews": "Recensioni in evidenza",
  Hostels: r,
  Hotels: l,
  "Information icon": "Icona di informazione",
  "No reviews found": "Nessun risultato trovato",
  "Pet-friendly": "Adatto agli animali domestici",
  "Posted on {reviewer}": "Pubblicato su {reviewer}",
  "Read Reviews": "Vedi le recensioni",
  Resorts: c,
  Restaurants: m,
  "Review Summary": "Riepilogo recensioni",
  "Reviews by Source": "Recensioni per fonti"
};
export {
  e as Aparthotels,
  i as Apartments,
  s as Business,
  t as Campsites,
  o as Couple,
  n as Family,
  a as Friend,
  r as Hostels,
  l as Hotels,
  c as Resorts,
  m as Restaurants,
  p as default
};
//# sourceMappingURL=it.iwCUWtsr.js.map
